<template>
  <div id="modalOverlay">
      <div id="modalWindow">
        <div class="row">
          <div class="col-sm-12" style="margin-bottom: 15px;">
            <h3>Add New Asset</h3>
          </div>
        </div>
        <form @submit.prevent="addAsset">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label>Name of Plant</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="asset.name" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Make</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="asset.make" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Serial</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="asset.serial" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Type</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text"  v-model="asset.type" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Model</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text"  v-model="asset.model" />
              </div>
            </div>
            
            
          </div>
          <div class="col-sm-6">
            
            <div class="row">
              <div class="col-sm-4">
                <label>Refrigeration Type</label>
              </div>
              <div class="col-sm-8">
                <div class="commerceSelect">
                    <select v-model="asset.refrigeration_type">
                      <option value="R449A">R449A</option>
                      <option value="R452A">R452A</option>
                      <option value="R404A">R404A</option>
                      <option value="R32">R32</option>
                      <option value="R410A">R410A</option>
                      <option value="R134A">R134A</option>
                      <option value="R290">R290</option>
                      <option value="R600">R600</option>
                      <option value="6407C">6407C</option>
                      <option value="R407F">R407F</option>
                      <option value="R448A">R448A</option> 
                    </select>
                  </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Amount of gas (Kg)</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="asset.refrigeration_quantity_kg" />
              </div>
            </div>
            
            <div class="row">
              <div class="col-sm-12">
                <div align="right">
                  <button type="submit" name="submit">Create Asset</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
        <router-link :to="{name: 'RelationshipsAssets', params: { id: $route.params.id }}"><font-awesome-icon icon="plus" class="modalClose" /></router-link>
      </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      asset: {}
    }
  },
  methods: {
    addAsset () {
      this.asset.company_id = this.$route.params.id
      axios
        .post('/api/assets/', this.asset)
        .then(response => (
          this.$toast.success("Asset created", {}),
          this.$router.push({ name: 'RelationshipsAssets', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    }
  }
}
</script>
